module.exports = __webpack_public_path__ + "img/icon_exchange_exchange.118b533d.png";